import React, { FC } from 'react'
import { ICommonProps } from 'transfix-ui/components/SvgIcon/types'

export const NoLoadsToAccept: FC<ICommonProps> = () => (
  <svg width='63' height='64' viewBox='0 0 63 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M49.3788 0H41.8369V18.1465H49.3788V0Z' fill='#BEE7FD' />
    <path d='M49.3788 19.0683H41.8369V36.3457H49.3788V19.0683Z' fill='#BEE7FD' />
    <path d='M49.3788 37.2676H41.8369V55.019H49.3788V37.2676Z' fill='#BEE7FD' />
    <path d='M57.8173 0H50.2754V18.1465H57.8173V0Z' fill='#BEE7FD' />
    <path d='M57.8173 19.0683H50.2754V36.3457H57.8173V19.0683Z' fill='#BEE7FD' />
    <path d='M57.8173 37.2676H50.2754V55.019H57.8173V37.2676Z' fill='#BEE7FD' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.720215 57.6264C0.720215 57.3613 0.935118 57.1464 1.20021 57.1464H47.1374C47.4025 57.1464 47.6174 57.3613 47.6174 57.6264V63.526C47.6174 63.7911 47.4025 64.006 47.1374 64.006H1.20021C0.935118 64.006 0.720215 63.7911 0.720215 63.526V57.6264ZM1.68021 58.1064V63.046H46.6574V58.1064H1.68021Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.720215 54.9926C0.720215 54.7275 0.935118 54.5126 1.20021 54.5126H47.1374C47.4025 54.5126 47.6174 54.7275 47.6174 54.9926V57.6264C47.6174 57.8915 47.4025 58.1064 47.1374 58.1064H1.20021C0.935118 58.1064 0.720215 57.8915 0.720215 57.6264V54.9926ZM1.68021 55.4726V57.1464H46.6574V55.4726H1.68021Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M46.6572 54.9926C46.6572 54.7275 46.8721 54.5126 47.1372 54.5126H61.7728C62.0379 54.5126 62.2528 54.7275 62.2528 54.9926V57.6264C62.2528 57.8915 62.0379 58.1064 61.7728 58.1064H47.1372C46.8721 58.1064 46.6572 57.8915 46.6572 57.6264V54.9926ZM47.6172 55.4726V57.1464H61.2928V55.4726H47.6172Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M46.6572 57.6264C46.6572 57.3613 46.8721 57.1464 47.1372 57.1464H52.5168C52.7819 57.1464 52.9968 57.3613 52.9968 57.6264V63.526C52.9968 63.7911 52.7819 64.006 52.5168 64.006H47.1372C46.8721 64.006 46.6572 63.7911 46.6572 63.526V57.6264ZM47.6172 58.1064V63.046H52.0368V58.1064H47.6172Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M55.9399 57.6264C55.9399 57.3613 56.1548 57.1464 56.4199 57.1464H61.7995C62.0646 57.1464 62.2795 57.3613 62.2795 57.6264V63.526C62.2795 63.7911 62.0646 64.006 61.7995 64.006H56.4199C56.1548 64.006 55.9399 63.7911 55.9399 63.526V57.6264ZM56.8999 58.1064V63.046H61.3195V58.1064H56.8999Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.96582 36.82C4.96582 36.5549 5.18072 36.34 5.44582 36.34H23.6414C23.9065 36.34 24.1214 36.5549 24.1214 36.82V54.9929C24.1214 55.258 23.9065 55.4729 23.6414 55.4729H5.44582C5.18072 55.4729 4.96582 55.258 4.96582 54.9929V36.82ZM5.92582 37.3V54.5129H23.1614V37.3H5.92582Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.5435 36.34C14.8086 36.34 15.0235 36.5549 15.0235 36.82V43.1674C15.0235 43.4324 14.8086 43.6474 14.5435 43.6474C14.2784 43.6474 14.0635 43.4324 14.0635 43.1674V36.82C14.0635 36.5549 14.2784 36.34 14.5435 36.34Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.96582 18.6471C4.96582 18.382 5.18072 18.1671 5.44582 18.1671H23.6414C23.9065 18.1671 24.1214 18.382 24.1214 18.6471V36.8199C24.1214 37.085 23.9065 37.2999 23.6414 37.2999H5.44582C5.18072 37.2999 4.96582 37.085 4.96582 36.8199V18.6471ZM5.92582 19.1271V36.3399H23.1614V19.1271H5.92582Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.5435 18.1671C14.8086 18.1671 15.0235 18.382 15.0235 18.6471V24.9944C15.0235 25.2595 14.8086 25.4744 14.5435 25.4744C14.2784 25.4744 14.0635 25.2595 14.0635 24.9944V18.6471C14.0635 18.382 14.2784 18.1671 14.5435 18.1671Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.96582 0.447835C4.96582 0.182738 5.18072 -0.0321655 5.44582 -0.0321655H23.6414C23.9065 -0.0321655 24.1214 0.182738 24.1214 0.447835V18.6207C24.1214 18.8858 23.9065 19.1007 23.6414 19.1007H5.44582C5.18072 19.1007 4.96582 18.8858 4.96582 18.6207V0.447835ZM5.92582 0.927835V18.1407H23.1614V0.927835H5.92582Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.5435 -0.0321655C14.8086 -0.0321655 15.0235 0.182738 15.0235 0.447834V6.79516C15.0235 7.06026 14.8086 7.27516 14.5435 7.27516C14.2784 7.27516 14.0635 7.06026 14.0635 6.79516V0.447834C14.0635 0.182738 14.2784 -0.0321655 14.5435 -0.0321655Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.1616 36.82C23.1616 36.5549 23.3765 36.34 23.6416 36.34H41.8372C42.1023 36.34 42.3172 36.5549 42.3172 36.82V54.9929C42.3172 55.258 42.1023 55.4729 41.8372 55.4729H23.6416C23.3765 55.4729 23.1616 55.258 23.1616 54.9929V36.82ZM24.1216 37.3V54.5129H41.3572V37.3H24.1216Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M32.7393 36.34C33.0044 36.34 33.2193 36.5549 33.2193 36.82V43.1674C33.2193 43.4324 33.0044 43.6474 32.7393 43.6474C32.4742 43.6474 32.2593 43.4324 32.2593 43.1674V36.82C32.2593 36.5549 32.4742 36.34 32.7393 36.34Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.1616 18.6471C23.1616 18.382 23.3765 18.1671 23.6416 18.1671H41.8372C42.1023 18.1671 42.3172 18.382 42.3172 18.6471V36.8199C42.3172 37.085 42.1023 37.2999 41.8372 37.2999H23.6416C23.3765 37.2999 23.1616 37.085 23.1616 36.8199V18.6471ZM24.1216 19.1271V36.3399H41.3572V19.1271H24.1216Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M32.7393 18.1671C33.0044 18.1671 33.2193 18.382 33.2193 18.6471V24.9944C33.2193 25.2595 33.0044 25.4744 32.7393 25.4744C32.4742 25.4744 32.2593 25.2595 32.2593 24.9944V18.6471C32.2593 18.382 32.4742 18.1671 32.7393 18.1671Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M23.1616 0.447835C23.1616 0.182738 23.3765 -0.0321655 23.6416 -0.0321655H41.8372C42.1023 -0.0321655 42.3172 0.182738 42.3172 0.447835V18.6207C42.3172 18.8858 42.1023 19.1007 41.8372 19.1007H23.6416C23.3765 19.1007 23.1616 18.8858 23.1616 18.6207V0.447835ZM24.1216 0.927835V18.1407H41.3572V0.927835H24.1216Z'
      fill='#394657'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M32.7393 -0.0321655C33.0044 -0.0321655 33.2193 0.182738 33.2193 0.447834V6.79516C33.2193 7.06026 33.0044 7.27516 32.7393 7.27516C32.4742 7.27516 32.2593 7.06026 32.2593 6.79516V0.447834C32.2593 0.182738 32.4742 -0.0321655 32.7393 -0.0321655Z'
      fill='#394657'
    />
  </svg>
)
